export default "__VITE_ASSET__dab308cb__"